<script>
	import { setLang } from '../lang/lang.js';
	import { setContext } from 'svelte';
	import Widget from './Widget.svelte';

	let options = {...$$props};
	setContext('options', options);
	export let lang = 'en';
	setLang(lang);
</script>

<Widget />